module.exports = __webpack_public_path__ + "static/media/git_wizard.aeee2897.pdf";